import {ReactNode, useEffect} from 'react';
import {USER_AUTHENTICATED_EVENT} from '~/adapters/ciheader/windowMessages';
import {useAuth} from '~/auth/AuthContext';

export const AuthHeaderLoginListener = ({children}: {children: ReactNode}) => {
  const {loginSilently} = useAuth();

  useEffect(() => {
    window.addEventListener(USER_AUTHENTICATED_EVENT, () => {
      // eslint-disable-next-line no-console
      console.log('User authenticated in ci-header');
      loginSilently();
    });
  }, []);

  return children;
};
